import React from 'react';
import './MappingDashboard.css';
import { MappingStats } from '../../types/columnMappingReview';

interface MappingDashboardProps {
  stats: MappingStats;
  onViewConflicts: () => void;
}

const MappingDashboard: React.FC<MappingDashboardProps> = ({ stats, onViewConflicts }) => {
  const formatNumber = (num: number) => {
    return num.toLocaleString();
  };

  const getUsagePercentage = () => {
    if (stats.total_mappings === 0) return 0;
    return Math.round((stats.active_mappings / stats.total_mappings) * 100);
  };

  return (
    <div className="mapping-dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{formatNumber(stats.total_mappings)}</div>
          <div className="stat-label">Total Mappings</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{formatNumber(stats.active_mappings)}</div>
          <div className="stat-label">Active (Last 30 days)</div>
          <div className="stat-subtext">{getUsagePercentage()}% usage rate</div>
        </div>

        <div className="stat-card warning">
          <div className="stat-value">{formatNumber(stats.stale_mappings)}</div>
          <div className="stat-label">Stale (90+ days)</div>
          {stats.stale_mappings > 0 && (
            <div className="stat-action">Review recommended</div>
          )}
        </div>

        <div className="stat-card">
          <div className="stat-value">{formatNumber(stats.recently_modified)}</div>
          <div className="stat-label">Modified This Week</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{formatNumber(stats.unique_domains)}</div>
          <div className="stat-label">Unique Domains</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{formatNumber(stats.dormant_mappings)}</div>
          <div className="stat-label">Dormant Mappings</div>
          {stats.dormant_mappings > 10 && (
            <div className="stat-action">Consider cleanup</div>
          )}
        </div>
      </div>

      <div className="dashboard-actions">
        <button className="action-button" onClick={onViewConflicts}>
          View Conflicts
        </button>
      </div>
    </div>
  );
};

export default MappingDashboard;